import { apiClient } from './client';
import { getCookie, setCookie, removeCookie, MAX_AGE } from '../utils/cookies';

type Provider = 'google' | 'apple';

export const auth = {
    login: async (code: string, provider: Provider) => {
      try {
        removeCookie('token');
        const response = await apiClient.post(`/auth/${provider}/`, {
          code: code,
        });
        
        if (response.data?.key) {
          setCookie('token', response.data.key, { maxAge: MAX_AGE });
          return response.data.key;
        }
        
        throw new Error('No authentication key received');
      } catch (error) {
        console.error('Login failed:', error);
        throw error;
      }
    },
    
    async logout() {
      removeCookie('token');
    },
  
    async status() {
      const token = getCookie('token');
      if (!token) {
        return false;
      }
  
      try {
        const response = await apiClient.get('/auth/status/');
        return response.status === 200;
      } catch (error) {
        console.error('Auth check failed:', error);
        return false;
      }
    }
  };
  